export const ADD_CATEGORIES = 'ADD_CATEGORIES'
export const ADD_CATEGORY = 'ADD_CATEGORY'
export const SET_IMAGE = 'SET_IMAGE'

